/**
 *    Note:
 *     In addition to simply containing string entries with drag group ids
 *       the array can contain entries which are an array of drag group
 *
 *    When an entry is itself an array, all of the drag group ids with the
 *      entry array must match the dragged group ids to be considered a match
 *      (and an array entry will never be considered a match if its length is 0)
 *
 *  The dropzone will accept drops so long as any entry is a match
 **/
export type DropzoneDragGroupIds = (string | string[])[]

/**
 * Specifies whether an element associated with the supplied dropzone drag group ids
 *  should accept drops of the specified activated dropzone drag group ids
 *  (and consequently become "Entered" while the dragged element is hovering over it)
 *
 * @param dropzoneDragGroupIdOrIds
 *  A single drag group id or an array of drag group ids associated with a dropzone
 *    When an array -- all of the drag group ids in the array must match the
 *    dragged group ids to be considered a match
 *    (and an array entry will never be considered a match if its length is 0)
 *  The dropzone will accept drops so long as any entry is a match
 *
 * @param activatedDropzoneDragGroupIds
 *  An array with the drag group ids associated with the dragged element in question
 *   filtering out any disabled drag groups
 */
const shouldAcceptDrop = (
  dropzoneDragGroupIdOrIds: string | string[],
  activatedDropzoneDragGroupIds: string[],
) =>
  Array.isArray(dropzoneDragGroupIdOrIds)
    ? dropzoneDragGroupIdOrIds.length > 0 &&
      dropzoneDragGroupIdOrIds.every((groupId) =>
        activatedDropzoneDragGroupIds.includes(groupId),
      )
    : activatedDropzoneDragGroupIds.includes(dropzoneDragGroupIdOrIds)

export default shouldAcceptDrop
